import React, { FC, useContext, useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { IntlContext } from "@app/provider";
import { HEAP_EVENTS } from "@app/provider/types";
import { usePatientEducation } from "./patientEducation";
import { usePatientEducationHeap } from "@app/hooks/usePatientEducationHeap";

/**
 * Provider to track language switching in patient education flow
 * Follows the same pattern as PreBillHeapProvider
 */
const PatientEducationHeapProvider: FC = () => {
  const { currentLanguage } = useContext(IntlContext);
  const location = useLocation();
  const { publicClinicId } = usePatientEducation();
  const { trackEvent } = usePatientEducationHeap(publicClinicId);

  const prevLanguageRef = useRef(currentLanguage);

  useEffect(() => {
    // Check if we're on a patient education page
    const isPatientEducationPage = location.pathname.includes(
      "/education/prenatal"
    );

    // Track language change if we're on a patient education page and language changed
    if (isPatientEducationPage && prevLanguageRef.current !== currentLanguage) {
      trackEvent({
        eventKey: HEAP_EVENTS.upp_language,
        eventProperties: {
          updatedLanguage: currentLanguage,
        },
      });
    }

    prevLanguageRef.current = currentLanguage;
  }, [currentLanguage, location.pathname, trackEvent]);

  return <Outlet />;
};

export default PatientEducationHeapProvider;
